export const VALID_FILTER_REGEX = /[0-9]{1,4}/;

export const AMENITIES = {
    BABY_EQUIPMENT: '4',
    BALCONY: '2',
    FITNESS: '9',
    HEATING: '11',
    HOB: '20',
    IRONING: '14',
    KING_BED: '16',
    MICROWAVE: '18',
    OVEN: '20',
    SHEETS_PROVIDED: '3',
    TELEVISION: '25',
    TERRACE: '22',
    TUMBLE_DRIER: '17',
    WHIRLPOOL: '12'
};

export const HOUSE_RULES = {
    PETS_ALLOWED: '27'
};

export const LOCATION_TYPES = {
    BEACH: '30',
    NEAR_THE_SEA: '37',
    SKI_IN_SKI_OUT: '39',
    TOWN: '40'
};

export const PROPERTY_TYPES = {
    BED_AND_BREAKFAST: '61',
    GUEST_HOUSE: '72',
    CARAVANE: '78',
    CHAMBRE: '72',
    APARTMENT: '92',
    BOAT: '62',
    BUNGALOW: '63',
    CHALET: '66',
    CHATEAU: '67',
    COTTAGE: '69',
    FARMHOUSE: '71',
    VILLA: '83',
    CABIN: '64',
    HOUSE: '74',
    BARN: '60',
    CASTLE: '65',
    ESTATE: '70',
    LODGE: '76',
    RESORT: '79',
    STUDIO: '80',
    TOWNHOME: '82',
    YACHT: '84',
    HOUSEBOAT: '75',
    MILL: '77',
    TOWER: '81',
    SUITE: '73'
};

export const PROPERTIES_GOOD_FOR = {
    FAMILIES: '43'
};

export const EXPERIMENTS = {
    ADULT_GROUPS: '9991'
};

export const GROUPS = {
    AMENITIES: '1',
    HOUSE_RULES: '2',
    LOCATION_TYPES: '3',
    PROPERTIES_GOOD_FOR: '4',
    PROPERTY_TYPES: '6',
    BOOKINGS: '9',
    EXPERIMENTS: '999'
};

export const REVIEWS = {
    GREATER_THAN_4_STARS: '95'
};

function reverseMapping(result, [group, filters]) {
    return Object.assign(result, ...Object.values(filters)
        .map((filter) => ({[filter]: group})));
}

// {<filter>: <group>}, e.g. {[AMENITIES.HOB]: GROUPS.AMENITIES}
export const FILTER_GROUPS = Object.entries({
    [GROUPS.AMENITIES]: AMENITIES,
    [GROUPS.HOUSE_RULES]: HOUSE_RULES,
    [GROUPS.LOCATION_TYPES]: LOCATION_TYPES,
    [GROUPS.PROPERTIES_GOOD_FOR]: PROPERTIES_GOOD_FOR,
    [GROUPS.PROPERTY_TYPES]: PROPERTY_TYPES,
    [GROUPS.EXPERIMENTS]: EXPERIMENTS
}).reduce(reverseMapping, {});

export const SEGMENT_FILTERS = {
    FAMILIES: '43',
    PETS_ALLOWED: '27',
    BEACH: '30',
    RECOMEMDED_FOR_ADULT_GROUPS: '9991'
};

export const URGENCY_DESTINATION_MESSAGE_FILTERS = {
    DATE_REGEX: /20[0-9]{2}-[0-1][0-9]-[0-3][0-9]/,
    MESSAGE_TYPE_REGEX: /ICON_(TITLE)?_?TEXT_V\d/
};
